import React, {Component} from 'react';
import api from '../../../services/api';
import {Container} from './styles';
import {FiEye, FiEyeOff} from 'react-icons/fi';
import {Spinner} from 'react-activity';
import 'react-activity/dist/react-activity.css';
import logo from '../../../assets/logo/vermelho@3x.png';
import {Redirect} from 'react-router-dom';

export default class NovaSenha extends Component {

    constructor(props) {
        super(props);
        this.state = {
            senha1: '',
            senha2: '',
            jwt: '',
            verify: null,
            carregando: false,
            senha1Class: 'div-input',
            senha2Class: 'div-input',
            type: 'password',
            confirmed: false,
            redirect: null
        }
    }

    async decode() {
        let query = window.location.search.slice(1);
        let partes = query.split('=');
        let codigo = decodeURIComponent(partes[1]);
        let codigoDecodado = atob(codigo);
        this.setState({
            jwt: codigoDecodado
        });
        await this.verifyToken(codigoDecodado);
    }

    async verifyToken(data) {
        try {
            const verify = await api.get('api/verift', {
                headers: {
                    Authorization: `Bearer ${data}`
                }
            });
            if (verify.data === true) {
                this.setState({
                    verify: true
                });
            } else {
                this.setState({
                    verify: false
                })
            }
        } catch (error) {
            console.log(error);
        }
    }

    async mudarSenha(carregando) {
        const params = {
            newpass: this.state.senha2,
        }
        const token = this.state.jwt
        try {
            this.setState({
                carregando: true
            });
            const trocar = await api.post('api/attp', params, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            this.setState({
                carregando: false,
                confirmed: trocar.data
            })
        } catch (error) {
            console.log(error);
        }
    }

    handleEye() {
        const {type} = this.state;
        if (type !== 'text') {
            this.setState({
                type: 'text'
            })
        } else {
            this.setState({
                type: 'password'
            })
        }
    }

    componentDidMount() {
        this.decode();
    }

    handleInputs(event) {
        switch (event.target.name) {
            case 'senha1':
                this.setState({
                    senha1: event.target.value
                });
                if (this.state.senha2.length >= event.target.value.length && event.target.value !== this.state.senha2) {
                    this.setState({
                        senha2Class: "div-input-error"
                    })
                } else {
                    this.setState({
                        senha2Class: "div-input"
                    })
                }
                break;
            case 'senha2':
                this.setState({
                    senha2: event.target.value
                });
                if (event.target.value.length >= this.state.senha1.length && event.target.value !== this.state.senha1) {
                    this.setState({
                        senha2Class: "div-input-error"
                    })
                } else {
                    this.setState({
                        senha2Class: "div-input-focado"
                    })
                }
                break;
            default:
                break;
        }
    }

    render(){
        if (this.state.redirect) {
            return <Redirect push to="/" />
        }
        return(
            <Container>
                {
                    this.state.verify === null ?
                    null
                    : this.state.verify === false ?
                    <>
                    <img 
                        alt=""
                        src={logo}
                        className="logocompletovermelho" />
                    <div className="div-bem-vindo">
                                <span
                                className="sejabemvindo"
                                >Esse link não está mais disponível.</span>
                        </div>
                        <div className="div-botao">
                            <button
                            onClick={() => this.setState({redirect: true})}
                            className="botaologin-active"
                            >Ir para o Painel do Restaurante</button>
                        </div>
                    </>
                    : this.state.verify === true ?
                    <>
                        <img 
                        alt=""
                        src={logo}
                        className="logocompletovermelho" />

                        <div className="div-bem-vindo">
                                <span
                                className="sejabemvindo"
                                >{
                                    this.state.confirmed ? 
                                    'Sua senha foi alterada com sucesso!' : 'Digite sua nova senha nos campos abaixo'
                                }</span>
                        </div>
                    {
                        this.state.confirmed ?
                        null
                        :
                        <>
                        <div className={this.state.senha1Class}>
                            <input 
                                value={this.state.senha1}
                                onFocus={() => {
                                    this.setState({
                                        senha1Class: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        senha1Class: 'div-input'
                                    })
                                }}
                                onChange={event => this.handleInputs(event)}
                                name="senha1"
                                type={this.state.type}
                                required
                                />
                                <label htmlFor="" className="label-name">
                                    <span className="content-name">Digite sua nova senha</span>
                                </label>
                                <button
                                    className="botao-olho"
                                    onClick={() => this.handleEye()}
                                    >
                                    {
                                        this.state.type === 'password'
                                        ?
                                        <FiEyeOff color="#1c0506" className="i" />
                                        :
                                        <FiEye color="#1c0506" className="i" />
                                    }
                                </button>
                    </div>

                    <div className={this.state.senha2Class}>
                            <input 
                                value={this.state.senha2}
                                onFocus={() => {
                                    this.setState({
                                        senha2Class: 'div-input-focado'
                                    })
                                }}
                                onBlur={() => {
                                    this.setState({
                                        senha2Class: 'div-input'
                                    })
                                }}
                                onChange={event => this.handleInputs(event)}
                                name="senha2"
                                type="password"
                                required
                                />
                                <label htmlFor="" className="label-name">
                                    <span className="content-name">Confirme sua nova senha</span>
                                </label>
                    </div>

                    {this.state.senha2Class === 'div-input-error' ? 
                    <div className="div-invalido">
                        <span
                        className='texto-invalido'
                        >Senha não confere</span>
                    </div>    
                    : null}
                        </>
                    }
                    <div className="div-botao">
                    <button
                        onClick={() => (this.state.senha1.length && this.state.senha2.length >= 1) && this.state.senha2Class !== "div-input-error" && this.state.senha1 === this.state.senha2 && this.state.confirmed !== true
                            ? this.mudarSenha(this.state.carregando)
                            : this.state.confirmed === true ? this.setState({redirect: true}) : null}
                        className={(this.state.senha1.length && this.state.senha2.length >= 1) && this.state.senha2Class !== "div-input-error" && this.state.senha1 === this.state.senha2
                            ? 'botaologin-active'
                            : 'botaologin'}
                        >{this.state.carregando ? <Spinner
                            className='spinner'
                            color="#fff" size={11} speed={1} animating={true} />
                        : this.state.confirmed ? 'ir para o Painel do restaurante' : 'Mudar minha senha'}</button>
                    </div>
                    </>
                    : null
                }
            </Container>
        )
    }

}